import { useCoinPriceAPIStore, useInfoAPIStore } from '@/stores'
import type { Maybe, BaseCoinPrice, CoreNetwork } from '@/types'

export abstract class BaseCoin {
  abstract coin: Maybe<BaseCoin>
  abstract name?: string
  abstract symbol: string
  abstract iconUrl?: string
  abstract decimals: number
  abstract cmkId?: number
  abstract coinGeckoId?: string
  abstract priceInfo: Maybe<BaseCoinPrice>
  abstract explorerUrl?: string
  abstract explorerAddress?: string
  abstract explorerTransaction?: string
  abstract explorerContract?: string
  abstract color?: string
  abstract feeType?: string | number
  abstract coreNetwork?: CoreNetwork
  abstract supportNft?: boolean
  abstract networkSymbol?: string
  abstract networkIcon?: string
  abstract networkName?: string
  abstract networkDecimals?: number
  abstract networkPriceInfo?: Maybe<BaseCoinPrice>

  async updateCoinPrice(force: boolean | undefined = false) {
    if (!this.coinGeckoId) return
    const coinPriceAPIStore = useCoinPriceAPIStore()
    const infoAPIStore = useInfoAPIStore()

    await coinPriceAPIStore.fetchCoinPrice({
      coinGeckoIds: [this.coinGeckoId],
      currency: infoAPIStore.currentCurrency,
      force,
    })
  }
}
